import { DialogService } from '../service/dialog.service';
import { Constant } from "../constant";
import { Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomComponentService } from 'src/app/main/services/custom-component.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs';
declare let $: any;
export class ModalBase {
  public customComponentService: CustomComponentService;
  public dialog: DialogService;
  public activeModal: NgbActiveModal;
  public isDisabled: boolean = false;
  constructor(
    injector: Injector
  ) {
    this.customComponentService = injector.get(CustomComponentService);
    this.dialog = injector.get(DialogService);
    this.activeModal = injector.get(NgbActiveModal);
  }
  isValidated: boolean = false;
  amountBuy: any;
  feeBuy: any;
  expectedVolume: any;
  totalMoney: any;
  product: any;
  Constant = Constant;
  
  validated() {
    return true;
  }
  executeRequest(url, body, modal, message?, isNoShowMessage?) {
    this.isValidated = this.validated();
    if (!this.isValidated) {
      return;
    }
    return this.customComponentService.postRequest(environment.urlBackEnd + url, body)
    .pipe(
      map(
        (result: any) => {
          this.dismiss();
          if (!isNoShowMessage) {
            !message && this.dialog.showSuccess(result.message);
            if (message && message !== true) {
              this.dialog.showSuccess(message);
            }
          }
          return result;
        })
    )
   
  }
  cancel(modal) {
    this.activeModal.dismiss();
  }
  dismiss() {
    this.activeModal.dismiss();
  }
}